




















import Vue, {
    PropType,
} from 'vue';

export default Vue.extend({
    name: 'amount-suggestions',
    props: {
        amounts: {
            type: Array as PropType<number[]>,
            required: true,
        },

        gap: {
            type: String,
            default: '1',
            required: false,
        },

        currencySymbol: {
            type: String,
            default: '',
            required: false,
        },
    },
    methods: {
        onClickAmount(amount: number): void {
            this.$emit('amountSelect', amount);
        },
    },
});
